/**
 * Rounds latitude and longitude coordinates to a specified precision.
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @param {number} [decimalPlaces=5] - Number of decimal places (default: 5)
 * @returns {[number, number]} Rounded [lat, lng] as a tuple
 */
export function roundCoordinates(lat, lng, decimalPlaces = 5) {
    const factor = 10 ** decimalPlaces;
    return [
        Math.round(lat * factor) / factor,
        Math.round(lng * factor) / factor
    ];
}

export function getRoundedLatLngString(lat,lng,decimalPlaces) {
    let roundedCoordinates = roundCoordinates(lat, lng, decimalPlaces);
    return roundedCoordinates[0]?.toString()+"__"+roundedCoordinates[1]?.toString();
}